export default __webpack_public_path__ + "static/i-MedicalCard Elite_Shariah Concepts-2b93a95bb905d9533f109e2ea24665b6.pdf";